(function () {
  // Guards against re-running this whole file (and re-binding every listener
  // below) if the script tag is re-executed after the initial page load, e.g.
  // when Shopify's Theme Editor re-renders the metafields-temp section.
  // DOMContentLoaded only ever fires once per document, so without this guard
  // a bare addEventListener('DOMContentLoaded', ...) callback would silently
  // never run again on re-execution, leaving the wishlist save buttons dead
  // (see the identical fix applied to assets/top-bar.js).
  if (window.__clnfMetafieldsSaveArticleBound) return;
  window.__clnfMetafieldsSaveArticleBound = true;

  function initSaveArticle() {
  // Check if save button elements exist before proceeding
  const saveButton = document.querySelector(".save_button_style");
  if (!saveButton) {
    return; // Exit early if save button doesn't exist
  }

  let current_data_id = saveButton.getAttribute("current-blog-article-id");

  const SEPARATOR = "/";

  // Identify buttons more reliably
  function getButtonType(btn) {
    if (btn.classList.contains("shop-now-btn-1")) return "sidebar";
    if (btn.classList.contains("mobile-save-btn")) return "mobile";
    return "default";
  }

  function updateButtonUI(isSaved) {
    let btns = document.querySelectorAll(".save_button_style");
    btns.forEach((btn) => {
      const type = getButtonType(btn);
      let textSpan = btn.querySelector('.save-text');
      let icon = btn.querySelector('i.heart');

      if (isSaved) {
        btn.classList.add("save_post_to_user");
        if (textSpan) textSpan.innerText = "Added to wishlist";
        if (icon) icon.classList.add("fa-heart");
      } else {
        btn.classList.remove("save_post_to_user");
        if (icon) icon.classList.remove("fa-heart");
        if (textSpan) {
          if (type === "sidebar") {
            textSpan.innerText = "Save This Blog";
          } else {
            textSpan.innerText = "Save this article!";
          }
        }
      }
    });
  }

  // Exact logic from working grid view but safer
  function getNewDataAll(currentDataId, isAdding) {
    let articleIdStr = localStorage.getItem("articleId") || "";
    // Clean up double slashes and split by separator
    let ids = articleIdStr.split(SEPARATOR).filter(id => id.trim() !== "");

    if (isAdding) {
      if (!ids.includes(currentDataId)) {
        ids.push(currentDataId);
      }
    } else {
      ids = ids.filter(id => id !== currentDataId);
    }

    // Grid view seems to prefer a leading slash or specific formatting sometimes
    // But standardizing on "ID1/ID2/ID3" is safest for .includes()
    return ids.join(SEPARATOR);
  }

  let initial_data_all = saveButton.getAttribute("data-all") || "";
  localStorage.setItem("articleId", initial_data_all);

  function checkIsSaved(data, id) {
    if (!data || !id) return false;
    let ids = data.split(SEPARATOR).filter(i => i.trim() !== "");
    return ids.includes(id);
  }

  if (checkIsSaved(initial_data_all, current_data_id)) {
    updateButtonUI(true);
  } else {
    updateButtonUI(false);
  }

  // Initial sync from server on page load if possible
  let customerId = saveButton.getAttribute("data-current-user-id");
  if (customerId) {
    syncFullWishlist(customerId, current_data_id);
  }

  let save_btn_click = document.querySelectorAll(".save_button_style");
  save_btn_click.forEach((cc) => {
    cc.addEventListener("click", function (e) {
      e.preventDefault();
      if (this.classList.contains("log-in-button")) {
        window.location.href = this.getAttribute("href");
        return;
      }
      setCustomerMetaField(this);
    });
  });

  /*save data into customer metafield using api call*/
  function setCustomerMetaField(clickedBtn) {
    let currentCustomerId = Number(clickedBtn.getAttribute("data-current-user-id"));
    let blogArticleId = clickedBtn.getAttribute("current-blog-article-id");
    let [blogIdStr, articleIdStr] = blogArticleId.split('-');
    let blogId = Number(blogIdStr);
    let articleId = Number(articleIdStr);

    let articleTitle = clickedBtn.getAttribute("data-article-title");
    let articleImage = clickedBtn.getAttribute("data-article-image");
    let articleUrl = clickedBtn.getAttribute("data-article-url");

    let data_all = localStorage.getItem("articleId") || "";
    let isCurrentlySaved = checkIsSaved(data_all, blogArticleId);
    let isAdding = !isCurrentlySaved;

    // Deduplication check: 
    // - If adding but already saved, skip
    // - If removing but not saved, skip
    if (isAdding && isCurrentlySaved) {
      return;
    }
    if (!isAdding && !isCurrentlySaved) {
      return;
    }

    // Optimistic UI update
    updateButtonUI(isAdding);

    let apiUrl = isAdding ? 'https://clnf.vercel.app/api/wishlist/add' : 'https://clnf.vercel.app/api/wishlist/remove';
    let method = isAdding ? 'POST' : 'DELETE';
    let body = isAdding ? {
      customerId: currentCustomerId,
      customer_id: currentCustomerId,
      blogId: blogId,
      blog_id: blogId,
      articleId: articleId,
      article_id: articleId,
      articleTitle: articleTitle,
      article_title: articleTitle,
      articleImage: articleImage,
      article_image: articleImage,
      articleUrl: articleUrl,
      article_url: articleUrl
    } : {
      customerId: currentCustomerId,
      customer_id: currentCustomerId,
      blogId: blogId,
      blog_id: blogId,
      articleId: articleId,
      article_id: articleId
    };

    fetch(apiUrl, {
      method: method,
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    })
      .then((res) => res.json())
      .then((data) => {
        // After success, fetch the full list to sync state correctly
        syncFullWishlist(currentCustomerId, blogArticleId);
      })
      .catch(() => {
        // Rollback on error
        updateButtonUI(!isAdding);
      });
  }

  function syncFullWishlist(customerId, current_data_id) {
    fetch(`https://clnf.vercel.app/api/wishlist/get?customerId=${customerId}`)
      .then(res => res.json())
      .then(data => {

        // Handle array or object structure
        let items = Array.isArray(data) ? data : (data.wishlist || data.articles || data.data || []);

        if (items) {
          // Standardize on CamelCase keys from API and deduplicate
          let idsSet = new Set();
          items.forEach(item => {
            let bId = item.blogId || item.blog_id;
            let aId = item.articleId || item.article_id;
            if (bId && aId) idsSet.add(`${bId}-${aId}`);
          });
          let ids = Array.from(idsSet);
          let final_data = ids.join(SEPARATOR);

          localStorage.setItem("articleId", final_data);
          let all_btns = document.querySelectorAll(".save_button_style");
          all_btns.forEach(btn => btn.setAttribute("data-all", final_data));

          // Final UI sync
          updateButtonUI(ids.includes(current_data_id));
        }
      })
      .catch(() => {});
  }

  const all_pTags = document.querySelectorAll("article .rte p");
  all_pTags.forEach((c) => {
    let text = c.innerHTML;
    if (text == "&nbsp;") {
      c.remove();
    }
  });
  }

  // This script loads with `defer`, so on a normal first page load
  // document.readyState is already 'interactive' by the time it runs (deferred
  // scripts execute after parsing but before DOMContentLoaded fires) — init
  // immediately in that case. If the script is later re-executed after the
  // document has fully loaded, readyState is 'complete', so we still init
  // immediately instead of registering a DOMContentLoaded listener that would
  // never fire again (that event only ever fires once per document).
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initSaveArticle);
  } else {
    initSaveArticle();
  }
})();
